module.exports = __webpack_public_path__ + "static/media/text-image.638c6730.avif";